import { render, staticRenderFns } from "./borrowInfo.vue?vue&type=template&id=f9943cfa&"
import script from "./borrowInfo.vue?vue&type=script&lang=js&"
export * from "./borrowInfo.vue?vue&type=script&lang=js&"
import style0 from "./borrowInfo.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports